import {jsx as $1w55K$jsx, jsxs as $1w55K$jsxs} from "react/jsx-runtime";
import {useRef as $1w55K$useRef, useState as $1w55K$useState, useCallback as $1w55K$useCallback, forwardRef as $1w55K$forwardRef, useEffect as $1w55K$useEffect, memo as $1w55K$memo} from "react";




const $9d8af3175088fc28$export$1896bab46732d207 = (ref, handler)=>{
    $1w55K$useEffect(()=>{
        const handleOutsideClick = (event)=>{
            if (!ref?.current?.contains(event.target)) handler?.(event);
        };
        document.addEventListener('click', handleOutsideClick);
        return ()=>{
            document.removeEventListener('click', handleOutsideClick);
        };
    });
};
const $9d8af3175088fc28$export$d58d7ee87dc3565d = ()=>{
};






function $842939989ecb6e26$export$b8c0badcc1d97290({ item: item , index: index , isHighlighted: isHighlighted , onMouseEnter: onMouseEnter , onClick: onClick , renderItem: renderItem , ...props }) {
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
    /*#__PURE__*/ $1w55K$jsx("li", {
        ...props,
        onClick: (event)=>onClick(event, {
                item: item,
                itemIndex: index
            })
        ,
        role: "option",
        "aria-selected": isHighlighted,
        onMouseEnter: (event)=>onMouseEnter(event, {
                item: item,
                itemIndex: index
            })
        ,
        children: renderItem(item, {
            isHighlighted: isHighlighted
        })
    }));
}
const $842939989ecb6e26$export$6d08773d2e66f8f2 = /*#__PURE__*/ $1w55K$memo($842939989ecb6e26$export$b8c0badcc1d97290);
$842939989ecb6e26$export$6d08773d2e66f8f2.displayName = 'AutocompletePureListItem';


function $b57ce3ed7cdda96b$var$InnerList({ items: items , highlightedItemIndex: highlightedItemIndex , className: className , itemClassName: itemClassName , renderItem: renderItem , onItemClick: onItemClick , onItemMouseEnter: onItemMouseEnter  }) {
    return(/*#__PURE__*/ $1w55K$jsx("ul", {
        role: "listbox",
        className: className,
        children: items.map((item, index)=>{
            const isHighlighted = highlightedItemIndex === index;
            return(/*#__PURE__*/ $1w55K$jsx($842939989ecb6e26$export$6d08773d2e66f8f2, {
                index: index,
                item: item,
                isHighlighted: isHighlighted,
                className: itemClassName,
                onClick: onItemClick,
                onMouseEnter: onItemMouseEnter,
                renderItem: renderItem
            }, index));
        })
    }));
}
const $b57ce3ed7cdda96b$export$54c2e3dc7acea9f5 = /*#__PURE__*/ $1w55K$memo($b57ce3ed7cdda96b$var$InnerList);
$b57ce3ed7cdda96b$export$54c2e3dc7acea9f5.displayName = 'AutocompletePureList';


const $780265d3efbf954d$var$DEFAULT_ITEM_INDEX = -1;
const $780265d3efbf954d$var$defaultRenderInput = (props)=>/*#__PURE__*/ $1w55K$jsx("input", {
        type: "text",
        ...props
    })
;
function $780265d3efbf954d$var$InnerAutocompletePure({ open: open , value: value1 , items: items = [] , theme: theme , renderItem: renderItem , renderInput: renderInput = $780265d3efbf954d$var$defaultRenderInput , renderContainer: renderContainer , getSuggestionValue: getSuggestionValue , onChange: onChange , onClickOutside: onClickOutside , onSelect: onSelect , onInputFocus: onInputFocus , ...props }, ref) {
    const containerRef = $1w55K$useRef(null);
    const inputValue = $1w55K$useRef(value1);
    const [highlightedItemIndex, setHighlightedItemIndex] = $1w55K$useState($780265d3efbf954d$var$DEFAULT_ITEM_INDEX);
    const handleInputKeyDown = (event)=>{
        const { code: code  } = event.nativeEvent;
        switch(code){
            case 'ArrowDown':
                {
                    event.preventDefault();
                    const nextItemIndex = highlightedItemIndex + 1;
                    const newItemIndex = nextItemIndex === items.length ? $780265d3efbf954d$var$DEFAULT_ITEM_INDEX : nextItemIndex;
                    const newValue = newItemIndex === $780265d3efbf954d$var$DEFAULT_ITEM_INDEX ? inputValue.current : getSuggestionValue(items[newItemIndex]);
                    setHighlightedItemIndex(newItemIndex);
                    onChange(event, {
                        value: newValue,
                        reason: 'ARROW'
                    });
                    break;
                }
            case 'ArrowUp':
                {
                    event.preventDefault();
                    const nextItemIndex = highlightedItemIndex - 1;
                    const newItemIndex = nextItemIndex < $780265d3efbf954d$var$DEFAULT_ITEM_INDEX ? items.length - 1 : nextItemIndex;
                    const newValue = newItemIndex === $780265d3efbf954d$var$DEFAULT_ITEM_INDEX ? inputValue.current : getSuggestionValue(items[newItemIndex]);
                    setHighlightedItemIndex(newItemIndex);
                    onChange(event, {
                        value: newValue,
                        reason: 'ARROW'
                    });
                    break;
                }
            case 'Enter':
                {
                    event.preventDefault();
                    const newValue = getSuggestionValue(items[highlightedItemIndex]);
                    setHighlightedItemIndex($780265d3efbf954d$var$DEFAULT_ITEM_INDEX);
                    onChange(event, {
                        value: newValue,
                        reason: 'ENTER'
                    });
                    break;
                }
            default:
        }
    };
    const handleInputChange = (event)=>{
        const { value: value  } = event.target;
        inputValue.current = value;
        setHighlightedItemIndex($780265d3efbf954d$var$DEFAULT_ITEM_INDEX);
        onChange(event, {
            value: value,
            reason: 'INPUT'
        });
    };
    const handleItemMouseEnter = $1w55K$useCallback((_event, { itemIndex: itemIndex  })=>{
        setHighlightedItemIndex(itemIndex);
    }, []);
    $9d8af3175088fc28$export$1896bab46732d207(containerRef, onClickOutside);
    const listComponent = /*#__PURE__*/ $1w55K$jsx($b57ce3ed7cdda96b$export$54c2e3dc7acea9f5, {
        items: items,
        highlightedItemIndex: highlightedItemIndex,
        renderItem: renderItem,
        className: theme?.list,
        itemClassName: theme?.item,
        onItemClick: onSelect,
        onItemMouseEnter: handleItemMouseEnter
    });
    return(/*#__PURE__*/ $1w55K$jsxs("div", {
        ref: containerRef,
        className: theme?.container,
        children: [
            renderInput({
                ...props,
                value: value1,
                onChange: handleInputChange,
                onKeyDown: handleInputKeyDown,
                onFocus: onInputFocus,
                ref: ref
            }),
            open && (renderContainer ? renderContainer({
                list: listComponent
            }) : listComponent)
        ]
    }));
}
const $780265d3efbf954d$export$fcfd28346f9e76c9 = /*#__PURE__*/ $1w55K$forwardRef($780265d3efbf954d$var$InnerAutocompletePure);
$780265d3efbf954d$export$fcfd28346f9e76c9.displayName = 'AutocompletePure';




export {$780265d3efbf954d$export$fcfd28346f9e76c9 as AutocompletePure};
//# sourceMappingURL=module.js.map
